import React, { useState, useRef } from "react";
import { Row, Col, Image, Button, Popover, Overlay } from "react-bootstrap";
import useAuth from "../hooks/UseAuth";
import SifLogo from "../../assets/sif-logo.svg";
import UpjLogo from "../../assets/upj-logo.svg";
import "../styles/header.css";

function Header() {
  const [showPopover, setShowPopover] = useState(false);
  const { logout, user } = useAuth();
  const imageRef = useRef(null);

  const handleTogglePopover = () => {
    setShowPopover(!showPopover);
  };

  const handleClosePopover = () => {
    setShowPopover(false);
  };

  if (!user) {
    return null;
  }

  const handleLogOut = () => {
    logout();
  };

  return (
    <Row className="d-flex justify-content-end align-items-center p-md-4 p-3 mb-5" id="header-container">
      <Col
        md={6}
        xs={7}
        className="d-flex justify-content-start align-items-center"
      >
        <Image
          src={user.photo_url}
          className="user-image"
          onClick={handleTogglePopover}
          ref={imageRef}
          roundedCircle
        />
        <p
          className="user-name text-center mb-0 ps-2 d-none d-sm-block"
          onClick={handleTogglePopover}
        >
          {user.name}
        </p>

        <Overlay
          show={showPopover}
          target={imageRef.current}
          placement="bottom"
          containerPadding={30}
          rootClose
          onHide={handleClosePopover}
        >
          <Popover id="popover-contained-client">
            <Popover.Header as="h3" className="popover-header-client">
              Profile
            </Popover.Header>
            <Popover.Body className="popover-body-client">
              <p className="mb-1">
                <strong>{user.name}</strong>
              </p>
              <p className="mb-3">{user.email}</p>
              <Button
                variant="danger"
                size="sm"
                onClick={handleLogOut}
                className="w-100 fw-bold"
              >
                <i className="bi bi-box-arrow-left"></i> {""}
                Sign out
              </Button>
            </Popover.Body>
          </Popover>
        </Overlay>
      </Col>
      <Col
        md={6}
        xs={5}
        className="d-flex justify-content-end align-items-center"
      >
        <div className="d-flex align-items-center justify-content-end gap-3">
          <Image src={UpjLogo} className="logo-header" />
          <Image src={SifLogo} className="logo-header" />
        </div>
      </Col>
    </Row>
  );
}

export default Header;
